export enum FirebaseFeatures {
    Analytics,
    Auth,
    RTDB,
    Functions,
}
